import eventBus from '../event-bus/event-bus';
import { getData } from '../store/store';
export default {
	methods: {
		handlePayload(payload) {
			this.model.other = payload;
		}
	},
	created() {
		const payload = getData();
		if (payload) {
			this.handlePayload(payload);
		}
		eventBus.$on('set-payload', this.handlePayload);
	}
};
